<template>
  <el-dialog
    v-if="visible"
    :visible="visible"
    :title="$l('INDEX.dialog_title_choose_amz_sku') || '选择亚马逊SKU'"
    show-close
    top="5vh"
    width="90%"
    :close-on-click-modal="false"
    :before-close="() => close()"
    v-el-dialog-drag
    :modal-append-to-body="false"
    :modal="false"
  >
    <Main
      ref="main"
      :amzPurchaseCode="amzPurchaseCode"
      @checkbox-change="(data) => (checkedRows = data)"
    />
    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-badge
        class="ml-2"
        :value="checkedRowCount"
        :hidden="!checkedRowCount"
      >
        <el-button
          type="primary"
          size="small"
          @click="confirm()"
          :disabled="!checkedRowCount"
        >
          {{ $l('INDEX.btn_confirm') || '确认' }}
        </el-button>
      </el-badge>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    amzPurchaseCode: { type: String, default: '' },
  },
  data() {
    return { checkedRows: null }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
      this.$refs.main.clearCheckboxRow()
    },
    confirm() {
      if (!this.checkedRowCount) return
      this.$emit('confirm', this.checkedRows)
      this.close()
    },
  },
}
</script>
